export default __webpack_public_path__ + "static/media/epi.39477225.svg";